import bareMetalService from '../../../api/bareMetalService'

export async function openDedicatedConsole(id: string): Promise<void> {
  // Open during the click: browsers may block windows opened after an API request.
  const consoleWindow = window.open('about:blank', '_blank')
  if (consoleWindow) consoleWindow.opener = null

  try {
    const { data } = await bareMetalService.getConsoleUrl(id)
    const url = new URL(data.access_url)
    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      throw new Error('Invalid console URL')
    }

    if (consoleWindow) {
      if (!consoleWindow.closed) consoleWindow.location.replace(url.href)
    } else {
      // Keep console access working when browser settings block even the initial tab.
      window.location.assign(url.href)
    }
  } catch (error) {
    consoleWindow?.close()
    throw error
  }
}
